module.exports = __webpack_public_path__ + "static/media/ss1.ab87bb26.jpg";